var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93238 6.35824C3.36496 5.7543 3.92445 5.25232 4.5716 4.88753C5.21875 4.52274 5.93788 4.30397 6.67854 4.24657V3.54657C6.67568 3.31834 6.73785 3.09401 6.85778 2.89981C6.97771 2.70561 7.15045 2.54956 7.35579 2.44991C7.55221 2.35428 7.77166 2.31613 7.98882 2.33987C8.20599 2.36361 8.41201 2.44827 8.58313 2.58407L11.7862 5.09707C12.0046 5.27076 12.1574 5.51348 12.2198 5.78544C12.2821 6.0574 12.2502 6.34247 12.1292 6.59391C12.0486 6.76063 11.9313 6.90699 11.7862 7.02207L8.58429 9.53507C8.41316 9.67088 8.20706 9.75545 7.98985 9.77899C7.77265 9.80253 7.55322 9.76407 7.35696 9.66807C7.15226 9.56828 6.98004 9.41251 6.86028 9.21882C6.74051 9.02513 6.67811 8.80146 6.68029 8.57374V8.02424C3.57113 8.77324 3.05663 11.0873 3.03446 11.1982C3.00958 11.3251 2.94317 11.4403 2.8457 11.5254C2.74823 11.6105 2.62523 11.6608 2.49604 11.6683H2.46104C2.33687 11.6682 2.21597 11.6285 2.11582 11.5551C2.01567 11.4817 1.94147 11.3784 1.90396 11.26C1.70961 10.4173 1.70092 9.54232 1.87851 8.69589C2.0561 7.84946 2.4157 7.0518 2.93238 6.35824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon3);
export default __webpack_public_path__ + "static/media/share_icon3.8e7dcda494fd62f490456312a450dc95.svg";
export { ForwardRef as ReactComponent };